import { Database } from './../database';
import { Injectable } from "@angular/core";

import 'rxjs/add/operator/map';

@Injectable()
export class BLLCariKartlar extends Database{
    eklenecek_carikartlar=[];
    guncellenecek_carikartlar=[];

    constructor(){
        super("NL_CariKart");
    }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-carikart.ts